import { OpenDialogWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('OpenDialog')
export class OpenDialogConnectorProvider extends ConnectorProvider<OpenDialogWorkflowNode> {}
